import React from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { LinkingType } from '@/types';
import { FilterItem, SingleFilterDropDown } from '@ygtechnologies/bygr-frontend-component-library';

interface TypeFilterProps {
    value?: LinkingType;
    onChange: (value?: LinkingType) => void;
}

export const TypeFilter: React.FC<TypeFilterProps> = ({ value, onChange }) => {
    const typeOptions: FilterItem[] = [
        // { id: 'all', name: t`All` },
        { id: LinkingType.Direct, name: t`Direct` },
        { id: LinkingType.Room, name: t`Room` },
    ];

    const selectedValue = typeOptions.find((x) => x.id == value) ?? null;

    return (
        <SingleFilterDropDown
            placeholder={t`Any type`}
            label={<Trans>Type</Trans>}
            data={typeOptions}
            value={selectedValue as any}
            onChange={(v) => onChange(v ? v.id : null)}
            isClearable
        />
    );
};
